<mat-card>
  <mat-card-header *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
      >{{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
    <button
      mat-icon-button
      *ngIf="canChange && src"
      icon="swap_horiz"
      [matTooltip]="'dashboard.operational.widgets.changeUrl' | t"
      matTooltipPosition="before"
      (click)="toggleChangeUrl()"
    >
      <mat-icon>swap_horiz</mat-icon>
    </button>
  </mat-card-header>
  <ng-container *ngIf="!src || changeUrl">
    <form [formGroup]="form" (ngSubmit)="submitForm()" class="twitter-form">
      <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      <div class="fs-text-right">
        <button mat-button color="success" type="submit" [disabled]="form.invalid || !canChange">
          {{ 'common.send' | t }}
        </button>
        <button
          mat-button
          *ngIf="changeUrl"
          color="danger"
          type="button"
          (click)="toggleChangeUrl()"
        >
          {{ 'common.cancel' | t }}
        </button>
      </div>
    </form>
  </ng-container>
  <div *ngIf="src && !changeUrl" class="twttrEmbed">
    <a class="twitter-timeline" data-lang="en" data-theme="dark" [attr.href]="src"> </a>
  </div>
</mat-card>

<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
